<script lang="ts">
  import { getLanguage } from "@/js/i18n";
  import { WORLD_MAP_URL } from "@/js/media";

  const langCode = getLanguage();
  const embedUrl = WORLD_MAP_URL + `?lang=${langCode}`;
</script>

<div class="iframe-wrapper">
  <iframe src={embedUrl} title="Coherence Word Map" allowfullscreen loading="lazy" frameborder="0"></iframe>
</div>

<style>
  .iframe-wrapper iframe {
    position: fixed;
    top: var(--f7-safe-area-top);
    left: 0;
    width: 100vw;
    height: 100vh;
    border: none;
  }
</style>
